import { lighten } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    height: 10,
    backgroundColor: lighten(theme.color.grey_d3, 0.5),
    borderRadius: 5,
  },
  bar: {
    borderRadius: 20,
    backgroundColor: theme.palette.primary.main,
  },
});

export default styles;
